/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { ConfirmedBookingsIndexResponse } from '../types/ConfirmedBookingsIndex'

/**
 * GET /interview-scheduling/bookings
 * @see backend/nexus/modules/InterviewScheduling/Http/Controllers/ConfirmedBookingsController.php ConfirmedBookingsController::index
 */
export async function confirmedBookingsIndex(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ConfirmedBookingsIndexResponse>> {
	return axiosInstance.get('/interview-scheduling/bookings', config)
}
